import PricingCard from "./PricingCard";
import { Flex } from '@chakra-ui/react';

const PricingCards = () => {
    return (
        <Flex
            flex={1}
            flexDirection={{
                base: 'column',
                md: 'row',
            }}
            justifyContent='space-between'
            alignItems='center'
        >
            <PricingCard
                title={'Basic'}
                subtitle={'Best small stores.'}
                price={'$ 0'}
                features={['10 users included', '2 GB of storage', 'Help center access', 'Email support']}
            />
            <PricingCard
                title={'Pro'}
                subtitle={'Best plan available.'}
                price={'$ 15'}
                features={['20 users included', '10 GB of storage', 'Help center access', 'Priority email support']}
                my={{
                    base: 5,
                    md: 0,
                }}
                mx={{
                    base: 0,
                    md: 5,
                }}
                recomended
            />
            <PricingCard
                title={'Enterprise'}
                subtitle={'Best for larger stores.'}
                price={'$ 29'}
                features={['50 users included', '30 GB of storage', 'Help center access', 'Phone & email support']}
            />
        </Flex>
    )
}

export default PricingCards;